import { Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverSendMessage extends Layout {
    checkboxArrival: Checkbox;
    checkboxCellPhone: Checkbox;
    checkboxComments: Checkbox;
    checkboxContactInfo: Checkbox;
    checkboxDirections: Checkbox;
    checkboxDirectionsDisclaimer: Checkbox;
    checkboxDistanceBetwStops: Checkbox;
    checkboxDoNotCall: Checkbox;
    checkboxOfficePhone: Checkbox;
    checkboxReferenceNumbers: Checkbox;
    checkboxSenderEmail: Checkbox;
    checkboxStopDetails: Checkbox;
    labelMessage: Label;
    labelOrder: Label;
    labelOrderId: Label;
    labelZmitTitle: Label;
    panelCharactersUsed: Panel;
    panelCheckboxes: Panel;
    panelContent: Panel;
    panelEmailFields: Panel;
    panelFields: Panel;
    panelLoadInfoComponents: Panel;
    panelLoadInformation: Panel;
    panelMessage: Panel;
    panelOrderId: Panel;
    panelSmsFields: Panel;
    panelTitle: Panel;
    sourceDriverSendMessage: DataSource;
    sourceMovementEquipment: DataSource;
    textboxCharactersRemaining: Textbox;
    textboxCharactersUsed: Textbox;
    textboxConsigneeName: Textbox;
    textboxDriver: Textbox;
    textboxDriverInfo: Textbox;
    textboxEmail: Textbox;
    textboxMessage: Textbox;
    textboxMobilePhone: Textbox;
    textboxNumOfTexts: Textbox;
    textboxShipperName: Textbox;
    textboxTractorId: Textbox;
    textboxTrailerId: Textbox;
}
